<template>
  <div class="booking-select">
    <div class="close-wrapper" @click="onClear">
      <i class="el-icon-circle-close close"></i>    
    </div>
    
    <div class="click-wrapper" v-on:click.stop="onSelectClick">
      <i class="el-icon-circle-check check"></i>
      <div class="select-title">{{title}}</div>
      
      <div class="select">
        <div class="placeholder" v-if="!showOptions && !selected"> {{placeholder}} </div>
        <div class="selected" v-else-if="!showOptions && selected">{{selected}}</div>
        <div class="options" v-else>
          <div class="option" 
            @click="onOptionClick(o)"
            v-for="o in options" 
            :key="o.id">
            {{ o.name }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'booking-select',
  props: ['title', 'placeholder', "options", 'selected', 'disabled'],
  data() {
    return {
      showOptions: false,
    }
  },
  methods: {
    onSelectClick(){
      if(this.showOptions) { 
        this.showOptions = false;
      } else {
        this.showOptions = true;
      }
    },
    onOptionClick(option){
      this.$emit('selected', option);
    },
    onClear(){
      this.selected = '';
      this.$emit('selected', '');
    }
  },
  watch: {
    'showOptions':function(val){
      // console.log(val);
    }
  },
  mounted(){
    // console.log('mounted');
  }
}
</script>

<style>
  .booking-select {
    padding: 0;
    margin: 0;
    border: 1px solid #eee;
    background-color: #fff;
 
    width: 100%;
    height: 80px;

    border-left: #33B0AE 2px solid; 

    position: relative;

    text-align: left;    
  }

  .booking-select i.check {
    font-size: 150%;
    float: left;
    margin-left: 10pt;
    color: #33B0AE;
  }

  .close-wrapper {
    float: right;
    width: 0; 
    height: 0; 
    border-top: 60px solid #F3F3F5; 
    border-left: 60px solid transparent;
    position: relative;
    cursor: pointer;
  }

  .close-wrapper:hover {
    border-top: 60px solid #FC7776; 
  }

  .close-wrapper:hover i.close {
    color: #D85C5B;

  }

  .booking-select i.close {
    font-size: 150%;
    color: #9B9B9B;
    position: absolute;
    top: -36pt;
    right: 5pt;
  }

  .click-wrapper {
    cursor: pointer;
  }

  .select-title {
    margin-left: 30pt;
    margin-top: 10pt;
    font-weight: bold;
    font-size: 110%;

  }

  .booking-select .select {
    width: 100%;

    margin-left: 30pt;
    margin-top: 10pt;
  }

  .placeholder, .selected {
    font-size: 120%;
    color: #ACACAC;
  }

  .options {
    width: 60%;
    border-radius: 5px;
    background-color: white;
    padding: 10pt;
    box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.2);
    position: absolute;
    z-index: 5000;
  }

  .option {
    border-bottom: 1px #eee solid;
    border-radius: 3px;
    padding: 16pt 8pt;
  }

  .option:hover {
    background: #33B0AE;
  }

</style>



// WEBPACK FOOTER //
// BookingSelect.vue?113b5390